import FindPageLayout from './layouts/FindPageLayout';
import LoadPageLayout from './layouts/LoadPageLayout';
// import { range, number2fileSize, text2number, number2text } from 'core/utils';
// import { representDate, representDateTime } from 'vue-core/i18n';

function install(Vue) {
  if (install.installed) return;

  install.installed = true;

  Vue.component('find-page-layout', FindPageLayout);
  Vue.component('load-page-layout', LoadPageLayout);

  /*
  Vue.prototype.$range             = (...args) => range(...args);
  Vue.prototype.$fileSize          = (...args) => number2fileSize(...args);
  Vue.prototype.$representDate     = (...args) => representDate(...args);
  Vue.prototype.$representDateTime = (...args) => representDateTime(...args);
  Vue.prototype.$text2number       = (...args) => text2number(...args);
  Vue.prototype.$number2text       = (...args) => number2text(...args);
  */
}

export default {
  install
};
